import api from './axiosInstance'; // 기존과 같이 api 인스턴스 사용
import { setCsrfToken } from './axiosInstance'; // CSRF 토큰 저장 함수 import

/**
 * 서버로부터 CSRF 토큰을 요청하고, 메모리에 저장하는 함수
 */
export const fetchCsrfToken = async () => {
  console.log(' [CSRF] CSRF/XSRF 토큰 요청 시작');

  try {
    // `/csrf-token` 엔드포인트에 GET 요청을 보냄
    // withCredentials: true → 쿠키 포함 요청 (서버에서 쿠키로 토큰을 내려줄 수 있음)
    const response = await api.get('/api/csrf-token', { withCredentials: true });

    // 전체 응답 로그 출력 (디버깅용)
    console.log(' [CSRF] /csrf-token 응답 전체:', response);
    console.log(' [CSRF] response.data:', response.data);

    // 응답에서 CSRF 토큰 추출 (기존 로직 유지)
    const csrfToken = response.data?.data?.token || response.data?.token;

    // 토큰이 존재할 경우, 메모리에 저장 (기존 방식 대신)
    if (csrfToken) {
      // 새로운 방식: 메모리에 저장
      setCsrfToken(csrfToken);

      // 기본 헤더에도 적용 (common 사용)
      api.defaults.headers.common['X-XSRF-TOKEN'] = csrfToken;

      console.log(' [CSRF] CSRF 토큰 설정 완료:', csrfToken);
      console.log(' [CSRF] axios.defaults.headers:', api.defaults.headers);
    } else {
      // 응답에 토큰이 없을 경우 경고 로그 출력
      console.warn(' [CSRF] 응답에 토큰이 없습니다.');
    }
    
    return response; // 기존과 같이 response 반환
  } catch (error) {
    // 요청 실패 시 에러 로그 출력 및 예외 던지기
    console.error(' [CSRF] 토큰 요청 실패:', error);
    throw error;
  }
};